import { gql } from "@apollo/client";

export const GENERATE_FUTURE_RENTALS_REPORT = gql`
  query generateFutureRentalReport($startMonth: String!, $endMonth: String!) {
    generateFutureRentalReport(startMonth: $startMonth, endMonth: $endMonth) {
      key
      message
    }
  }
`;